/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { AbstractFormComponent } from '@gh/builder-shared';
import { ContactTermsReceivables } from '@gh/builder-shared-data';
import { EnumDictionary } from '@gh/common-shared';

import { SystemVarsReceivables } from '../../../resources';
import { SystemVarsReceivablesFormState } from '../system-vars-receivables-form.service';

@Component({
  standalone: false,
  selector: 'gh-system-vars-receivables-common-settings-subtab',
  templateUrl: 'system-vars-receivables-common-settings-subtab.component.html',
  providers: [
    SystemVarsReceivablesFormState,
  ],
})
export class SystemVarsReceivablesCommonSettingsSubtabComponent extends AbstractFormComponent<SystemVarsReceivables> {
  @Input() form: SystemVarsReceivablesFormState;
  @Input() termsReceivables: EnumDictionary<ContactTermsReceivables>;

  get recDefaultPaymentBalanceDaysPlaceholder(): string {
    switch (this.form.get('recDefaultPaymentDue').value) {
      case ContactTermsReceivables.OnMonthDay:
      case ContactTermsReceivables.MonthDayAfterEOM:
        return 'lbl_terms_due_day';
      default:
        return 'lbl_terms_balance_due';
    }
  }

  onRecDefaultPaymentDueChange(paymentDue: ContactTermsReceivables): void {
    this.form.disableOrEnableControlsByPaymentDue(paymentDue);
  }
}
